import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ModalMap from "components/shared/stays/ModalMap";
import MapStatic from "components/shared/stays/MapStatic";
import MapInteractive from "components/shared/stays/MapInteractive";
import styles from "components/shared/stays/MapSmall.module.scss";

export default function MapSmall({ trips }) {
  const [isDomReady, setIsDomReady] = useState(false);
  const [tripData, setTripData] = useState(null);
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    setTripData(trips);
  }, [trips]);

  useEffect(() => {
    setIsDomReady(true);
  }, []);

  return (
    <>
      <div className={styles.component}>
        <button
          className={styles.button}
          type="button"
          onClick={() => setShowMap(true)}
        >
          {isDomReady && tripData && <MapStatic trips={tripData} />}
        </button>
      </div>

      <ModalMap show={showMap} handleClose={() => setShowMap(false)}>
        <MapInteractive trips={trips} />
      </ModalMap>
    </>
  );
}

MapSmall.propTypes = {
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      address_lat: PropTypes.string,
      address_lng: PropTypes.string,
      city: PropTypes.string,
      city_destination_slug: PropTypes.string,
      country: PropTypes.string,
      country_destination_slug: PropTypes.string,
      id: PropTypes.string,
      is_featured: PropTypes.bool,
      lowest_price_per_person_per_night: PropTypes.number,
      lowest_product_pricing_type: PropTypes.string,
      main_image: PropTypes.shape({
        url: PropTypes.string,
        content_type: PropTypes.string,
        byte_size: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
      name: PropTypes.string,
      region: PropTypes.string,
      region_destination_slug: PropTypes.string,
      region_seasons: PropTypes.arrayOf(PropTypes.string),
      slug: PropTypes.string,
      trip_media_images: PropTypes.arrayOf(
        PropTypes.shape({
          created_at: PropTypes.string,
          file: PropTypes.shape({
            url: PropTypes.string,
            content_type: PropTypes.string,
            byte_size: PropTypes.number,
            width: PropTypes.number,
            height: PropTypes.number,
          }),
          id: PropTypes.number,
          position: PropTypes.number,
        })
      ),
      trip_type_description: PropTypes.string,
    })
  ),
};
